// extracted by mini-css-extract-plugin
module.exports = {"images-summary":"images-summary--29tWL","resume":"resume--18Fz3","children":"children---FfFu"};